import { useState } from 'preact/hooks';

interface FormData {
  name: string;
  email: string;
  phone: string;
  message: string;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function EscalationForm({
  busy,
  onSubmit,
  onChatAgain
}: {
  busy: boolean;
  onSubmit: (data: FormData) => void;
  /** Escape hatch: the form is also what a visitor lands on after reloading a
   *  terminal conversation, so give them a way back to a fresh chat. */
  onChatAgain: () => void;
}) {
  const [data, setData] = useState<FormData>({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [emailErr, setEmailErr] = useState(false);

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    if (!EMAIL_RE.test(data.email.trim())) {
      setEmailErr(true);
      return;
    }
    onSubmit({
      name: data.name.trim(),
      email: data.email.trim(),
      phone: data.phone.trim(),
      message: data.message.trim()
    });
  };

  return (
    <form class="escalation-form" onSubmit={handleSubmit}>
      <div class="escalation-field">
        <label htmlFor="esc-name">Name (optional)</label>
        <input
          id="esc-name"
          type="text"
          value={data.name}
          maxLength={200}
          onInput={(e) => setData({ ...data, name: (e.target as HTMLInputElement).value })}
          disabled={busy}
        />
      </div>
      <div class="escalation-field">
        <label htmlFor="esc-email">
          Email <span class="required">*</span>
        </label>
        <input
          id="esc-email"
          type="email"
          value={data.email}
          required
          onInput={(e) => {
            setData({ ...data, email: (e.target as HTMLInputElement).value });
            if (emailErr) setEmailErr(false);
          }}
          disabled={busy}
          aria-invalid={emailErr}
        />
        {emailErr && <div class="escalation-error">Please enter a valid email.</div>}
      </div>
      <div class="escalation-field">
        <label htmlFor="esc-phone">Phone (optional)</label>
        <input
          id="esc-phone"
          type="tel"
          value={data.phone}
          maxLength={40}
          onInput={(e) => setData({ ...data, phone: (e.target as HTMLInputElement).value })}
          disabled={busy}
        />
      </div>
      <div class="escalation-field">
        <label htmlFor="esc-message">Anything else? (optional)</label>
        <textarea
          id="esc-message"
          value={data.message}
          rows={3}
          maxLength={4000}
          onInput={(e) =>
            setData({ ...data, message: (e.target as HTMLTextAreaElement).value })
          }
          disabled={busy}
        />
      </div>
      <button type="submit" class="escalation-submit" disabled={busy}>
        {busy ? 'Sending…' : 'Send message'}
      </button>
      <button
        type="button"
        class="escalation-secondary"
        disabled={busy}
        onClick={onChatAgain}
      >
        Chat again
      </button>
    </form>
  );
}
